import type { TFunction } from "react-i18next";
import { isBlank } from "utils/string";
import { isEmptyArray } from "utils/isEmptyArray";
import { FormErrors, FormState } from "./types";

export const NAME_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 500;

export function validate(values: FormState, t: TFunction): FormErrors {
  const errors: FormErrors = {};

  if (isBlank(values.name)) {
    errors.name = t("form.name.required");
  } else if (values.name.trim().length > NAME_MAX_LENGTH) {
    errors.name = t("form.name.maxLength", { max: NAME_MAX_LENGTH });
  }

  if (
    !isBlank(values.description) &&
    values.description.length > DESCRIPTION_MAX_LENGTH
  ) {
    errors.description = t("form.description.maxLength", {
      max: DESCRIPTION_MAX_LENGTH,
    });
  }

  const predicateErrors = values.predicates.map(p => {
    const errors: FormErrors["predicates"][number] = {};

    if (isEmptyArray(p.variableIdList)) {
      errors.variableIdList = t("form.predicates.variableId.required");
    }

    return errors;
  });

  if (predicateErrors.some(e => Object.keys(e).length > 0)) {
    errors.predicates = predicateErrors;
  }

  return errors;
}

export function hasErrors(errors: FormErrors): boolean {
  return Object.keys(errors).length > 0;
}
